import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Notes } from '../models/note';
import { Settings } from './settings';
import {NoteCategory} from "../models/note-category";

@Injectable({
  providedIn: 'root'
})
export class NoteService {

  constructor(private http: HttpClient) { }

  createNote(record: Notes): Observable<any> {
      return this.http.post(Settings.getInstance().BASE_URL + 'notes/notes', record)
      .pipe(
        retry(1)
      );
  }
  updateNote(record: Notes): Observable<any> {
        return this.http.put(Settings.getInstance().BASE_URL + 'notes/notes/' + record.id , record)
            .pipe(
                retry(1)
            );
    }
  deleteNote(id: number): Observable<any> {
      return this.http.delete(Settings.getInstance().BASE_URL + 'notes/notes/' + id)
      .pipe(
        retry(1)
      );
  }
  getNotesByForeignKeyId(foreignKeyId: number, foreignKeyTable: string,restrictedAgencyFlag: boolean = false): Observable<any> {
      return this.http.get<Notes>(Settings.getInstance().BASE_URL + 'notes/notes/' + foreignKeyTable + '/' + foreignKeyId + '/' + restrictedAgencyFlag)
      .pipe(
        retry(1)
      );
  }

    /** Note Categories **/

    getAllActiveNoteCategories(): Observable<any> {
        return this.http.get<any>(Settings.getInstance().BASE_URL + 'notes/note-categories/active/')
            .pipe(
                retry(1)
            );
    }
    getNoteCategories(): Observable<any> {
        return this.http.get<any>(Settings.getInstance().BASE_URL + 'notes/note-categories/' )
            .pipe(
                retry(1)
            );
    }

    createNoteCategory(record: NoteCategory): Observable<any> {
        return this.http.post(Settings.getInstance().BASE_URL + 'notes/note-categories/', record)
            .pipe(
                retry(1)
            );
    }
    updateNoteCategory(record: NoteCategory): Observable<any> {
        return this.http.put(Settings.getInstance().BASE_URL + 'notes/note-categories/' + record.id , record)
            .pipe(
                retry(1)
            );
    }
    deleteNoteCategory(id: number): Observable<any> {
        return this.http.delete(Settings.getInstance().BASE_URL + 'notes/note-categories/' + id)
            .pipe(
                retry(1)
            );
    }

}
